// Espelha ATS.Hub.API.Compras/Enums/CriterioCotacaoEnum.cs (domínio public.criterio_cotacao).
export enum CriterioCotacaoEnum {
  MenorPrecoTotal = 1,
  MenorPrazoEntrega = 2,
  MenorFrete = 3,
  DefinidoManualmente = 4,
}
